import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";

import "./NavBar.css";
import AppLogos from "../logos/AppLogos";
import TextBox from "../textBox/TextBox";
import IconsEnum from "../../classes/enums/IconsEnum";
import IconButton from "../iconButton/IconButton";
import UserButton from "../userButton/UserButton";
import NavBarButton from "../navBarButton/NavBarButton";
import LangSwitcher from "../langSwitcher/LangSwitcher";
import ToggleThemeButton from "../toggleThemeButton/ToggleThemeButton";

import useTranslation from "../../hooks/i18n/useTranslation";

function NavBar() {
  const { t } = useTranslation();
  const location = useLocation();
  const [searchText, setSearchText] = useState("");
  const [isCollapsed, setIsCollapsed] = useState(false);

  useEffect(() => {
    if (
      location.pathname.startsWith("/plan") ||
      location.pathname.startsWith("/patientDashboard")
    ) {
      setIsCollapsed(true);
    } else setIsCollapsed(false);
  }, [location.pathname]);

  function toggleNavbar() {
    setIsCollapsed(!isCollapsed);
  }

  return (
    <div
      className={`App-navigation-bar-container ${
        isCollapsed ? "collapsed" : ""
      }`}
    >
      <div className={`App-navigation-bar ${isCollapsed ? "collapsed" : ""}`}>
        <div className="App-navigation-bar-trick">
          <AppLogos />
        </div>
        <div className="App-navigation-bar-left-side">
          <IconButton icon={IconsEnum.SHIELDCHECKED} isLightBlue={false} />
          <TextBox
            placeholder={t("5")}
            value={searchText}
            onChange={e => setSearchText(e.target.value)}
          />
          <span>{t("25")}</span>
          <span>{t("26")}</span>
          <LangSwitcher />
        </div>
        <div className="App-navigation-bar-right-side">
          <IconButton icon={IconsEnum.AR} isCircle={false} />
          <UserButton />
          <NavBarButton value={t("27")} />
          <ToggleThemeButton />
        </div>
      </div>
      <div className="App-navigation-bar-tab" onClick={toggleNavbar}></div>
    </div>
  );
}

export default NavBar;
